export default {

    methods: {

        /**
         * let swalOptions = {
         *                         icon: 'warning',
         *                         title: 'You have unsaved Changes',
         *                         successCallback: successCallback,
         *                         description: 'When a connection is changed, any unsaved changes are lost.',
         *                         confirmButtonText: 'Save and Change',
         *                         cancelButtonText: 'Cancel',
         *                         cancelCallback: cancelCallback,
         *                         successText: 'Connection Changed!',
         *                         denyButtonText: 'Change without saving',
         *                         denyCallback: denyCallback,
         *                     }
         */
        swalConfirmation(options) {

            let self = this

            let successCallback;
            let cancelCallback;
            let denyCallback;
            let title = 'Are you sure?';
            let description = false;
            let denyButtonText = false;
            let showDenyButton = false;
            let confirmButtonText = false;
            let icon = 'info';
            let cancelButtonText = 'Cancel';
            let successText = false;
            let allowOutsideClick = false;
            let showCancelButton = true;


            if (options.hasOwnProperty('successCallback') && typeof options.successCallback === 'function') {
                successCallback = options.successCallback;
            }
            if (options.hasOwnProperty('cancelCallback') && typeof options.cancelCallback === 'function') {
                cancelCallback = options.cancelCallback;
            }
            if (options.hasOwnProperty('denyCallback') && typeof options.denyCallback === 'function') {
                denyCallback = options.denyCallback;
            }
            if (options.hasOwnProperty('title') && typeof options.title === 'string') {
                title = options.title;
            }
            if (options.hasOwnProperty('description') && typeof options.description === 'string') {
                description = options.description;
            }
            if (options.hasOwnProperty('denyButtonText') && typeof options.denyButtonText === 'string') {
                denyButtonText = options.denyButtonText;
                showDenyButton = true;
            }
            if (options.hasOwnProperty('confirmButtonText') && typeof options.confirmButtonText === 'string') {
                confirmButtonText = options.confirmButtonText;
            }
            if (options.hasOwnProperty('icon') && typeof options.icon === 'string') {
                icon = options.icon;
            }
            if (options.hasOwnProperty('cancelButtonText') && typeof options.cancelButtonText === 'string') {
                cancelButtonText = options.cancelButtonText;
            }
            if (options.hasOwnProperty('successText') && typeof options.successText === 'string') {
                successText = options.successText;
            }
            if (options.hasOwnProperty('allowOutsideClick') && typeof options.allowOutsideClick === 'boolean') {
                allowOutsideClick = options.allowOutsideClick;
            }
            if (options.hasOwnProperty('showCancelButton') && typeof options.showCancelButton === 'boolean') {
                showCancelButton = options.showCancelButton;
            }

            this.$swal.fire({
                title,
                html: description,
                showCancelButton: showCancelButton,
                showDenyButton: typeof denyButtonText === 'string',
                confirmButtonText,
                cancelButtonText: typeof cancelButtonText !== 'string' ? 'Cancel' : cancelButtonText,
                denyButtonText,
                icon,
                allowOutsideClick
            }).then(function (result) {

                if (result.isConfirmed) {
                    if (typeof successCallback === 'function') {
                        if (successCallback(self)) {
                            if (successText && successText.length > 0) {
                                self.$refs.snackbar.showSnackbar(successText)
                            }
                        }
                    }
                } else if (result.isDenied) {

                    if (typeof denyCallback === 'function') {
                        denyCallback(self)
                    }

                } else {
                    if (typeof cancelCallback === 'function') {
                        cancelCallback(self)
                    }
                }

            })
        },

    }

}
